<template>
	<div id="manual-data-list-view">
		<div class="vx-row">
			<div class="vx-col w-full flex items-center p-2">
				<feather-icon
					class="g-breadcrumb--title"
					icon="ChevronLeftIcon"
					svgClasses="h-8 w-8"
					@click.prevent="handleBack"
				/>
				<vs-breadcrumb
					class="g-breadcrumb--title"
					separator=""
					:items="[{title: $t('general.Return')}]"
					@click.prevent="handleBack"
				></vs-breadcrumb>
			</div>
		</div>
		<bread-crumbs
			:title="$t('ManualData.ManageError')"
			:sizeTitle="22"
			:lineHeightTitle="27"
			:sizeSubTitle="13"
			:lineHeightSubTitle="16"
		>
		</bread-crumbs>
		<vx-card>
			<div class="vx-row">
				<div class="vx-col w-full sm:w-1/1 lg:w-1/1 mb-base">
					<div class="flex justify-start flex-wrap">
						<feather-icon
							style="color: #0b8ff4"
							icon="FilePlusIcon"
							class="bg-white mr-2 rounded-full"
							svgClasses="w-16 h-16"
						></feather-icon>
						<div class="my-3 ml-3">
							<h5 class="g-subtitle mb-2">
								{{ $t("UploadFiles.UploadType") }} :
								<span class="g-span-RememberPassword" v-text="uploadFile.category_name"></span>
							</h5>
							<h5 class="g-subtitle">
								{{ $t("ObjectType") }} :
								<span class="g-span-RememberPassword" v-text="uploadFile.typology_name"></span>
							</h5>
						</div>
					</div>
					<vs-divider></vs-divider>
					<div class="flex justify-between flex-wrap">
						<span>
							<p class="g-table--title">{{ $t("Name") }} : {{ uploadFile.original_name }}</p>
							<p class="g-table--title">{{ $t("Status") }} : {{ uploadFile.process_state }}</p>
							<p class="mt-2 g-label--normal text-danger" v-if="dataFiles.length > 0">
								{{ $t("ManualData.ErrorsFound") }}
							</p>
							<p class="mt-2 g-label--normal text-success" v-else>
								{{ $t("ManualData.ErrorsNotFound") }}
							</p>
						</span>
						<span>
							<vs-button
								v-if="isFileOnFirebase"
								@click="download"
								class="mt-4 mr-2 shadow-lg"
								type="filled"
								color="primary"
								>{{ $t("ManualData.DownloadFile") }}</vs-button
							>
							<vs-button
								v-if="isFileOnFirebase"
								@click="handleProcessAgain"
								class="mt-4 mr-2 shadow-lg"
								type="filled"
								color="success"
								>{{ $t("ManualData.ProcessAgain") }}</vs-button
							>
						</span>
					</div>
				</div>
			</div>
			<vs-table
				v-if="dataFiles.length > 0"
				ref="table"
				:multiple="false"
				v-model="selected"
				pagination
				:max-items="itemsPerPage"
				search
				:data="dataFiles"
			>
				<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between"></div>
				<template slot="thead">
					<vs-th class="g-table--title" sort-key="category">{{ $t("Description") }}</vs-th>
					<vs-th class="g-table--title">{{ $t("Actions") }}</vs-th>
				</template>
				<template slot-scope="{data}">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td class="g-table--description">
								<!-- Collapse -->
								<manual-data-list-item
									ref="ManualDataListItem"
									:data="tr"
									:category_name="uploadFile.category_name"
									:roles="roles"
									:edit="edit"
									@resolveManualDataEmit="resolveManualData"
								/>
							</vs-td>
							<vs-td class="g-table--description whitespace-no-wrap">
								<feather-icon
									:title="$t('ManualData.ShowErrors')"
									icon="AlertTriangleIcon"
									svgClasses="w-5 h-5 text-danger stroke-current"
									class="g-label--normal"
									@click.stop="toggleManualDataItem(indextr)"
								/>
								<feather-icon
									:title="$t('ManualData.FixErrorsHere')"
									v-if="uploadfileUpdatePermission"
									class="ml-2 g-label--normal"
									icon="Edit2Icon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="changeEdit(indextr)"
								/>
								<feather-icon
									:title="$t('ManualData.FixErrorsModule')"
									class="ml-2"
									v-if="uploadfileUpdatePermission && uploadFile.category_name !== 'SCHEDULE'"
									icon="ExternalLinkIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="editData(tr)"
								/>
								<feather-icon
									:title="$t('ManualData.SaveChanges')"
									class="ml-2"
									style="display: none"
									icon="SaveIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="save(indextr)"
									ref="BtnSave"
								/>
								<feather-icon
									:title="$t('Crud.Delete')"
									v-if="uploadfileDeletePermission"
									icon="Trash2Icon"
									svgClasses="w-5 h-5 hover:text-danger stroke-current"
									class="ml-2"
									@click.stop="openConfirm(tr.id)"
								/>
							</vs-td>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
		</vx-card>

		<vs-prompt
			:title="$t('ManualData.ProcessAgain')"
			@cancel="closePrompt"
			@accept="acceptPrompt"
			@close="closePrompt"
			:active.sync="activePrompt"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
		>
			<div class="con-exemple-prompt">
				<p>{{ $t("ManualData.ProcessAgainText") }}</p>
				<div class="mt-4">
					<form>
						<label class="vs-input--label">{{ $t("Role") }}</label>
						<v-select
							v-model="role_local_sel"
							:clearable="false"
							:options="roleOptions"
							v-validate="'required'"
							name="role"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
						<span class="text-danger text-sm" v-show="error_role">{{ $t("Roles.SelectRole") }}</span>
					</form>
				</div>
			</div>
		</vs-prompt>

		<vs-popup :title="popupTitle" :active.sync="popupActiveAlert">
			<alert size="small" :title="alert_title" :message="alert_message" :color="alert_color"></alert>
		</vs-popup>
	</div>
</template>

<script>
import vSelect from "vue-select";
import moduleManualData from "@/store/manual-data/moduleManualData";
import UploadedFile from "@/models/UploadedFile.js";
import VisitPoint from "@/models/VisitPoint.js";
import ManualDataListItem from "./ManualDataListItem.vue";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import Commons from "@/helpers/commons.js";
import Alert from "@/components/alerts/Alert.vue";

export default {
	components: {
		ManualDataListItem,
		vSelect,
		Alert,
	},
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					actionDropdown: true,
					btnAssigGroup: false,
					columns: ["name", "description", "address", "hour_init", "hour_end", "action"],
				};
			},
		},
	},
	data() {
		return {
			selected: [],
			files: [],
			itemsPerPage: 10,
			isMounted: false,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
			groupDelete: null,
			dataId: 0,
			uploadFile: new UploadedFile({}),
			activePrompt: false,
			role_local_sel: {label: this.$t("Select"), value: null},
			roles: [],
			edit: false,
			popupActiveAlert: false,
			alert_title: "",
			alert_message: "",
			alert_color: "",
			popupTitle: "",
			fixManualdata: false,
			manualDataRegister: null,
			error_role: false,
			isFileOnFirebase: false,
		};
	},
	computed: {
		uploadfileDeletePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_D");
		},
		uploadfileUpdatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_U");
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		dataFiles() {
			return this.$store.state.moduleManualData.issues;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.dataFiles.length;
		},
		roleOptions() {
			const res = Commons.generateSelectOptios(this.roles, "alias", "id");
			return res === undefined || res === null || res.length === 0 ? [] : res;
		},
	},
	methods: {
		handleBack() {
			this.$router.push({
				name: "app-upload-files",
				params: {active_tab: 0},
			});
		},
		manageErrorAlert(err) {
			const {title, text} = Commons.manageErrorValidator.call(this, err);
			const findErrorNameProperty = Commons.findErrorNamePropertyValidator();
			const nameProperty = findErrorNameProperty(err);
			this.alert_title = `${title}`;
			this.alert_message = `${this.$t("ManualData.PropertyError")} ${nameProperty}: ${text}`;
			this.alert_color = "danger";
			this.popupTitle = this.$t("ErrorTitle");
			this.popupActiveAlert = true;
		},
		toggleManualDataItem(item) {
			this.$refs.ManualDataListItem[item].toggleFeatures();
		},
		changeEdit(item) {
			this.$refs.ManualDataListItem[item].changeEditMode();
			if (this.$refs.BtnSave[item].style.display === "none") {
				this.$refs.BtnSave[item].style.display = "inherit";
			} else {
				this.$refs.BtnSave[item].style.display = "none";
			}
		},
		save(item) {
			this.$refs.ManualDataListItem[item].getData();
		},
		resolveManualData(resolvedData) {
			this.fixManualdata = true;
			this.manualDataRegister = resolvedData;
			if (this.uploadFile.category_name === "SCHEDULE") {
				this.resolveManualDataEvent(resolvedData);
			} else if (this.uploadFile.category_name === "VISIT_POINT") {
				this.resolveManualVisitpoint(resolvedData);
			} else if (this.uploadFile.category_name === "RESOURCE") {
				if (!resolvedData.role_id) {
					this.activePrompt = true;
				} else {
					this.resolveManualResource();
				}
			} else {
			}
		},
		resolveManualDataEvent({register, id}) {
			this.openLoading();
			this.$store
				.dispatch("moduleManualData/updateManualdataEvent", {register, id})
				.then((res) => {
					this.showDeleteSuccess();
					this.closeLoading();
				})
				.catch((err) => {
					this.manageErrorAlert(err);
					this.closeLoading();
				});
		},
		resolveManualVisitpoint({register, id}) {
			this.openLoading();
			this.$store
				.dispatch("moduleManualData/updateManualdataVisitpoint", {
					manual_data_id: id,
					visit_point: register,
				})
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("VisitPointObject.Create.Success.Title"),
						text: this.$t("VisitPointObject.Create.Success.Text"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorAlert(err);
				});
		},
		resolveManualResource() {
			if (!this.role_local_sel.value) {
				this.activePrompt = true;
				this.error_role = true;
				return;
			}
			this.manualDataRegister.register["role_id"] = this.role_local_sel.value;
			if (this.manualDataRegister.register.hasOwnProperty("email")) {
				this.manualDataRegister.register.email = this.manualDataRegister.register.email.toLowerCase();
			}
			this.openLoading();
			this.$store
				.dispatch("moduleManualData/updateManualdataResource", {
					resource_data: this.manualDataRegister.register,
					manual_data_id: this.manualDataRegister.id,
				})
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("Resource.Create.Success.Title"),
						text: this.$t("Resource.Create.Success.Text"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorAlert(err);
				});
		},
		getIssues() {
			this.openLoading();
			this.$store
				.dispatch("moduleManualData/fetchIssuesListItemsByIdUploadedFile", this.uploadFile.id)
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		deleteRecord() {
			this.openLoading();
			this.$store
				.dispatch("moduleManualData/removeManualdataItem", this.dataId)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					this.closeLoading();
					if (err.response.status === 404) {
						return;
					}
				});
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		enableHeadTable(headName) {
			return this.customConfig.columns.includes(headName);
		},
		showDeleteSuccess() {
			this.closeLoading();
			this.$vs.notify({
				color: "success",
				title: this.$t("Record.TitleConfirmRecordDelete"),
				text: this.$t("Record.TextConfirmRecordDelete"),
			});
		},
		openConfirm(id) {
			this.dataId = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Record.DeleteRecord"),
				text: this.$t("Record.DeleteRecordConfirmText"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		editData(object) {
			//  creacion de un punto de vista
			const {category_id, typology_id, typology_name} = {
				...this.uploadFile,
			};
			const datos = {
				...object.register,
				category_id,
				typology_id,
				typology_name,
			};

			if (this.uploadFile.category_name === "RESOURCE") {
				this.$router.push({
					name: "app-resource-create",
					params: {
						resource_data: datos,
						manual_data_id: object.id,
						upload_file_id: object.upload_file_id,
					},
				});
			} else if (this.uploadFile.category_name === "VISIT_POINT") {
				const visitPoint = new VisitPoint(datos);
				this.$router.push({
					name: "app-visit-point-create",
					params: {
						visit_point: visitPoint,
						manual_data_id: object.id,
						upload_file_id: object.upload_file_id,
					},
				});
			} else {
			}
		},
		cahngeCurrentPageLocal() {
			this.currentPageLocal = 1;
			/*  this.getGroups({page:val, quantity: this.itemsPerPage})   */
		},
		handleProcessAgain() {
			if (this.uploadFile.category_name === "RESOURCE") {
				this.activePrompt = true;
			} else {
				this.openConfirmAgain();
			}
		},
		openConfirmAgain() {
			this.$vs.dialog({
				type: "confirm",
				color: "primary",
				title: this.$t("ManualData.ProcessAgain"),
				text: this.$t("ManualData.ProcessAgainText"),
				accept: this.processAgain,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		processAgain() {
			const url = this.uploadFile.bucket_path;
			if (!url) return;

			const payload = {
				bucket_path: url,
				original_name: this.uploadFile.original_name,
				typology_id: this.uploadFile.typology_id,
				public: true,
			};

			if (this.uploadFile.category_name === "RESOURCE") {
				payload["role_id"] = this.role_local_sel.value;
			}
			this.openLoading();

			downloadFileFromFirebase(url)
				.then((res) => {
					return this.$store.dispatch("uploadFile/saveUploadFile", payload);
				})
				.then((res) => {
					// check the notification
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("ManualData.ProcessAgain"),
						text: this.$t("ManualData.ProcessAgainTextSuccess"),
						time: 6000,
					});
				})
				.catch((error) => {
					this.closeLoading();
					this.processFirebaseError(error);
				});
		},
		download() {
			const url = this.uploadFile.bucket_path;
			if (!url) return;
			downloadFileFromFirebase(url)
				.then((res) => {
					this.uploadFile.downloadFile(this.uploadFile.original_name, res);
				})
				.catch((error) => {
					this.processFirebaseError(error);
				});
		},
		processFirebaseError(error) {
			let msg = "";
			if (error.code && error.code === "storage/object-not-found") {
				msg = `El Archivo ${this.uploadFile.bucket_path} no fue encontrado`;
			} else {
				msg = this.$t("ErrorMessage");
			}
			this.$vs.notify({
				color: "danger",
				title: this.$t("ErrorTitle"),
				text: msg,
				time: 5000,
			});
		},
		acceptPrompt() {
			if (this.fixManualdata) {
				this.resolveManualResource();
			} else {
				this.processAgain();
			}
		},
		closePrompt() {
			this.error_role = false;
		},
		fetchRoleStatusCategoryTypology() {
			const payload = {role: []};
			this.$store
				.dispatch("moduleCommon/fetchDataRoleStatusCategoryTypology", payload)
				.then((res) => {
					this.roles = res.data.role;
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		existFile() {
			const url = this.uploadFile.bucket_path;
			if (!url) return;
			downloadFileFromFirebase(url)
				.then((res) => {
					this.isFileOnFirebase = true;
				})
				.catch((error) => {
					this.isFileOnFirebase = false;
				});
		},
	},
	watch: {
		itemsPerPage(val) {
			/*  this.getGroups({page:1, quantity: val}) */
			this.currentPageLocal = 1;
		},
	},
	created() {
		if (!moduleManualData.isRegistered) {
			this.$store.registerModule("moduleManualData", moduleManualData);
			moduleManualData.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		this.$store.commit("moduleManualData/SET_ISSUES", []);
		const payload = {
			id: [this.$route.params.id],
		};
		this.openLoading();
		this.$store
			.dispatch("uploadFile/getUploadFilter", payload)
			.then((res) => {
				this.uploadFile = new UploadedFile(res.records[0]);
				if (this.uploadFile.id > 0) {
					return this.$store.dispatch(
						"moduleManualData/fetchIssuesListItemsByIdUploadedFile",
						this.uploadFile.id
					);
				} else {
					return [];
				}
			})
			.then((res) => {
				this.closeLoading();
				this.existFile();
			})
			.catch((err) => {
				this.closeLoading();
			});

		this.fetchRoleStatusCategoryTypology();
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss" scoped>
#manual-data-list-view {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.5rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			padding: 0 1rem;

			td {
				font-style: normal;
				font-weight: 300;
				font-size: 12px;
				line-height: 15px;
				color: #666666;
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}

.vs-popup--content-custom {
	.vs-popup--content {
		height: 100%;
	}

	.btn-save {
		position: absolute;
		bottom: 30px;
	}

	.btn-del {
		position: absolute;
		left: 200px;
		bottom: 30px;
	}
}
</style>
